module.exports = __webpack_public_path__ + "img/extract_hit_light.6ed15fc5.png";